import { render, staticRenderFns } from "./ARegEstudiante.vue?vue&type=template&id=6d9b70a4"
import script from "./ARegEstudiante.vue?vue&type=script&lang=js"
export * from "./ARegEstudiante.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports